<template>
    <div class="loading-text">
      <div class="loader"></div>
      <span>{{ text }}</span>
    </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: 'Thinking...',
    },
  },
};
</script>
<style lang="less" scoped>
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.loading-text {
  display: flex;
  align-items: center;
  width: fit-content;
  height: 49px;
  padding: 12px;
  border-radius: 11px;
  background: #fff;
  .loader {
    margin-right: 8px;
    border-radius: 50%;
    border: 2px solid #686868;
    border-top: 2px solid #d9d9d9;
    width: 13px;
    height: 13px;
    -webkit-animation: spin 1.5s linear infinite;
    animation: spin 1.5s linear infinite;
  }
}
</style>
